import React from "react";
import PropTypes from "prop-types";
import Score from "./Score";
import SocialLinks from "./SocialLinks";


class QuizPopup extends React.Component {
  render () {
    return (
      <div
        ref={this.props.innerRef}
        id='quiz-popup'
        className='ignore-click fixed popup full-height full-width top left flex-container align-center-middle flex-dir-column secondary-bg'
      >

        {!this.props.survey &&
          <React.Fragment>
            <h2 className='text-center lmb'>Before you get your final score ...</h2>

            {/* Link To Future, passing Survey id  */}
            <a href={`/future?id=${this.props.id}`} >
              <button className='button'>
                Next
              </button>
            </a>
          </React.Fragment>
        }

        {this.props.survey &&
          <div>
            <Score survey={this.props.finishedSurvey} />
            <SocialLinks />
          </div>
        }

      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <QuizPopup
  innerRef={ref} {...props}
/>);
